const COLOR_AVATAR_CONFIG = {
    green: { imageType: 1, fallbackKey: 'GREEN_DEFAILT_AVATAR' },
    '#CCCCFF': { imageType: 5, fallbackKey: 'PURPLE_DEFAILT_AVATAR' },
    red: { imageType: 2, fallbackKey: 'RED_DEFAILT_AVATAR' },
}

const getImageByType = (member, type) => member?.memberImageList
    ?.find(item => item.type === type)
    ?.image

const resolveImage = (image, fallback, imageFooter) => image ? image + imageFooter : fallback

export function getDefaultMemberAvatar(member, icons) {
    return resolveImage(
        getImageByType(member, 0),
        icons.KEPENG_LOGO,
        icons.ImageFooter,
    )
}

export function getTeamColorAvatar(member, color, icons) {
    const config = COLOR_AVATAR_CONFIG[color]
    if (!config) return icons.KEPENG_LOGO

    return resolveImage(
        getImageByType(member, config.imageType),
        icons[config.fallbackKey],
        icons.ImageFooter,
    )
}

export function getMatchMemberAvatar(member, gameDetail, icons) {
    if ([1, 2, 3].includes(member?.gameType)) {
        return resolveImage(
            getImageByType(member, 3),
            icons.REFEREE_DEFALT_AVATAR,
            icons.ImageFooter,
        )
    }

    if (member?.gameRole === 1 && member?.gameType === 0) {
        return resolveImage(
            getImageByType(member, 4),
            icons.KEPENG_LOGO,
            icons.ImageFooter,
        )
    }

    if (member?.gameType === 0 && member?.gameTeam === 1) {
        return getTeamColorAvatar(member, gameDetail?.greenColor, icons)
    }

    if (member?.gameType === 0 && member?.gameTeam === 2) {
        return getTeamColorAvatar(member, gameDetail?.redColor, icons)
    }

    return getDefaultMemberAvatar(member, icons)
}

